<template>
  <div id="app">
    <the-header v-if="$route.name!=='Login' && $route.name!=='Admin'"></the-header>
    <router-view/>
    <the-footer v-if="$route.name!=='Login' && $route.name!=='Admin'"></the-footer>
  </div>
</template>

<script>
    import TheHeader from "./components/TheHeader";
    import TheFooter from "./components/TheFooter";

    export default {
      name:'App',
      components:{
        TheHeader,
        TheFooter
      }
    }
</script>

<style lang="scss">
  @import 'assets/scss/app.scss';
</style>
